import { useMutation } from "react-query"
import { apiClient } from "../apiClient/apiService"
import ApiEndpoints, { ROUTES } from "../apiClient/apiEndpoints"

interface Form {
  type: string
  ticket_id: any
}

const useGetFormById = () => {
  return useMutation({
    mutationFn: (data: Form) => {
      return apiClient.post(ApiEndpoints.POST[ROUTES.postGetFormByKeyId], data)
    },
  })
}

export default useGetFormById
